<kendo-formfield>
    <kendo-label [text]="caption | translate"></kendo-label>
    <!-- <kendo-textarea 
    [ngClass]="{'fx-fill': settings.fxFill}"  
    [formControl]="control" 
    (valueChange)="onChange($event)" 
    [rows]="settings.rows" 
    width="auto" > 
</kendo-textarea> -->

<kendo-editor style="height: auto;"  [formControl]="control" >
    <kendo-toolbar>
      <kendo-toolbar-buttongroup>
        <kendo-toolbar-button kendoEditorBoldButton></kendo-toolbar-button>
        <kendo-toolbar-button kendoEditorItalicButton></kendo-toolbar-button>
        <kendo-toolbar-button kendoEditorUnderlineButton></kendo-toolbar-button>
      </kendo-toolbar-buttongroup>


    <kendo-toolbar-colorpicker
      kendoEditorForeColor view="gradient"
    ></kendo-toolbar-colorpicker>
    <kendo-toolbar-colorpicker
      kendoEditorBackColor view="gradient"
    ></kendo-toolbar-colorpicker>

        <kendo-toolbar-dropdownlist
          kendoEditorFormat *ngIf="extendedVersion"
        ></kendo-toolbar-dropdownlist>
        <kendo-toolbar-dropdownlist
          kendoEditorFontSize *ngIf="extendedVersion"
        ></kendo-toolbar-dropdownlist>
         <kendo-toolbar-dropdownlist
          kendoEditorFontFamily *ngIf="extendedVersion"
        ></kendo-toolbar-dropdownlist>

        <kendo-toolbar-buttongroup *ngIf="extendedVersion">
          <kendo-toolbar-button
            kendoEditorAlignLeftButton
          ></kendo-toolbar-button>
          <kendo-toolbar-button
            kendoEditorAlignCenterButton
          ></kendo-toolbar-button>
          <kendo-toolbar-button
            kendoEditorAlignRightButton
          ></kendo-toolbar-button>
          <kendo-toolbar-button
            kendoEditorAlignJustifyButton
          ></kendo-toolbar-button>
        </kendo-toolbar-buttongroup>

        <kendo-toolbar-buttongroup *ngIf="extendedVersion">
          <kendo-toolbar-button
            kendoEditorInsertUnorderedListButton
          ></kendo-toolbar-button>
          <kendo-toolbar-button
            kendoEditorInsertOrderedListButton
          ></kendo-toolbar-button>
          <kendo-toolbar-button kendoEditorIndentButton></kendo-toolbar-button>
          <kendo-toolbar-button kendoEditorOutdentButton></kendo-toolbar-button>
        </kendo-toolbar-buttongroup>
        <kendo-toolbar-button
          kendoEditorBlockquoteButton
        ></kendo-toolbar-button>
        <kendo-toolbar-button kendoEditorSelectAllButton></kendo-toolbar-button>
        <kendo-toolbar-buttongroup>
          <kendo-toolbar-button kendoEditorUndoButton></kendo-toolbar-button>
          <kendo-toolbar-button kendoEditorRedoButton></kendo-toolbar-button>
        </kendo-toolbar-buttongroup>

    </kendo-toolbar>
  </kendo-editor>

</kendo-formfield>
